import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Course, Lesson } from '../models/Course';
import {
  getAssignedLessonIds,
  getCompletedLessonsByCourseId,
  getCourseList,
  getLessonsByCourseId,
} from '../services/CourseService';
import _ from 'lodash';

export const useCourseDetail = (courseId?: string) => {
  const [selectedCourseId, setSelectedCourseId] = useState(0);
  const [courseList, setCourseList] = useState<Course[]>([]);
  const [lessonList, setLessonList] = useState<Lesson[]>([]);
  const [assignedLessonIds, setAssignedLessonIds] = useState<number[]>([]);
  const [completedLessonList, setCompletedLessonList] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetch = async () => {
      if (!courseId || isNaN(Number.parseInt(courseId))) return;
      setIsLoading(true);
      const res = await Promise.all([
        getCourseList(),
        getLessonsByCourseId(Number.parseInt(courseId)),
        getCompletedLessonsByCourseId(Number.parseInt(courseId)),
        getAssignedLessonIds('en'),
      ]);

      setIsLoading(false);
      setSelectedCourseId(
        _.find(res[0], (item) => item.id === Number.parseInt(courseId))
          ? Number.parseInt(courseId)
          : -1,
      );
      setCourseList(res[0]);
      setLessonList(res[1]);
      setCompletedLessonList(res[2] as number[]);
      setAssignedLessonIds(res[3] as number[]);
    };
    fetch();
  }, [courseId, location.key]);

  return {
    selectedCourseId,
    courseList,
    lessonList,
    completedLessonList,
    assignedLessonIds,
    loading: isLoading,
  };
};
